import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { MenuStore } from './menu.store';

@Injectable({
    providedIn: 'root'
})
export class MenuQuery extends BaseQuery {

    constructor(store: MenuStore) {
        super(store);
    }


}
